<script setup lang="ts">
  import { computed, onMounted, ref, watch } from 'vue'
  import api from '../../api'
  import SubscribePlans from '../../components/SubscribePlans.vue'
  import imgBannerPageFreeTour from 'assets/img/BannerPageFreeTour.webp'
  import { localeStore } from '../../stores/locale'
  import { planStore } from '../../stores/plans'
  import { useRoute } from 'vue-router'

  const storeLocale = localeStore()
  const storePlan = planStore()
  const route = useRoute()

  const reactiveLocale = computed(() => storeLocale.locale)
  const reactivePlans = computed(() => storePlan.plans)
  const imgBannerPromotion = ref('')

  watch(reactiveLocale, () => {
    getPlans()
  })

  onMounted(() => {
    if (reactiveLocale.value != storePlan.languagePlans || route.query.coupon) getPlans()
    imgBannerPromotion.value = getImagBannerPromotion()
  })
  function getImagBannerPromotion() {
    return imgBannerPageFreeTour
  }
  function getPlans() {
    api
      .get(
        `v1/home/getPlansFreeTour?language=${reactiveLocale.value ?? ''}&coupon=${
          route.query.coupon ?? ''
        }`
      )
      .then(({ data }) => {
        storePlan.setPlans(data.plansFreeTour)
      })
  }
</script>
<template>
  <div class="block block--break">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-6 mt-3">
          <router-link
            :to="{
              name: 'AssineOptionsPage',
              params: { locale: reactiveLocale },
              query: { acionador: `${String(route.name)} - Banner` }
            }"
          >
            <picture>
              <img
                :src="imgBannerPromotion"
                class="w-100"
                alt="Subscribe"
                width="615"
                height="454"
              />
            </picture>
          </router-link>
        </div>
        <div class="col-12 col-lg-6">
          <SubscribePlans
            :plans="reactivePlans"
            :showTitle="true"
            v-if="reactivePlans.length > 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
  .row > [class*='col-'] {
    padding: 6px 6px;
  }

  img {
    height: 454px;
    object-fit: cover;
    height: auto;
  }
</style>
